import React, { Component } from 'react'
import { connect } from 'react-redux'
import { updateFillValue } from '../actions/index'

class Radio extends Component {
  state = {
    value: ''
  }
  handleChange = (event) => {
    event.persist()
    this.setState((state) => {
      return {
        value: event.target.value
      }
    })
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.state.value !== prevState.value) {
      this.props.dispatch(updateFillValue(this.state.value))
    }
  }
  render() {
    var { answers } = this.props
    var checkBoxes = answers.map((answer, index) => (
      <div key={index} className="xmp-radio">
        <input onChange={this.handleChange} value={answer.value || answer} checked={(this.state.value == answer.value) || (this.state.value == answer)} type="radio" id={'radio' + index}/>
          <label htmlFor={'radio' + index} className="prettyradio"></label>
          <label htmlFor={'radio' + index}>{ answer.text || answer }</label>
      </div>
    )
  )
    return(
      <div className="xmp-radio-container">
        {checkBoxes}
      </div>
    )
  }
}

const Container = connect(() => {return {}})(Radio);

export default Container;



// WEBPACK FOOTER //
// ./src/components/Radio.js